var render = function (_h,_vm) {var _c=_vm._c;return _c('v-checkbox',_vm._g({attrs:{"value":_vm.props.value,"disabled":_vm.props.disabled,"color":"primary","ripple":false,"dense":"","hide-details":"","false-value":false,"id":_vm.props.id}},_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }